import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { PortalDatosComponent } from './portal-datos/portal-datos.component';
import { ReportComponent } from './report/report.component';
import { DescargasComponent } from './descargas/descargas.component';

const routes: Routes = [
  {
    path: '',
    data: { breadcrumb: 'Observatorio' },
    children: [
      {
        path: '',
        component: PortalDatosComponent,
        data: { breadcrumb: 'Portal de Datos' },
      },
      {
        path: 'reportes/:id',
        component: ReportComponent,
        data: { breadcrumb: 'Reporte de Datos' },
      },
      {
        path: 'descargas/:id',
        component: DescargasComponent,
        data: { breadcrumb: 'Descargas' },
      },
    ],
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class ObservatorioRoutingModule {}
